var rt = {
    tango: {
        "上手": "じょうず",
        "綺麗": "きれい",
        "彼女": "かのじょ",
        "場所": "ばしょ",
        "部屋": "へや",
        "子供": "こども",
        "相手": "あいて",
        "椅子": "いす",
        "天井": "てんじょう",
        "仕事": "しごと",
        "文句": "もんく",
        "手紙": "てがみ",
        "物音": "ものおと",
        "方向": "ほうこう",
        "動作": "どうさ",
        "場合": "ばあい",
        "仲間": "なかま",
        "仮名": "かな",
        "物事": "ものごと",
        "意味合い": "いみあい",
        "立場": "たちば",
        "企画": "きかく",
        "言葉": "ことば",
        "大雨": "おおあめ",
        "矢印": "やじるし",
        "明日": "あした",
        "昨日": "きのう",
        "今日": "きょう",
        "今年": "ことし",
        "夜中": "よなか",
        "風邪": "かぜ",
        "曜日": "ようび",
        "年下": "としした",
        "丁寧": "ていねい",
        "受身": "うけみ",
        "田中": "タナカ",
        "名前": "なまえ",
        "事柄": "ことがら",
        "計画": "けいかく",
        "横浜": "よこはま",
        "出方": "でかた",
        "間違": "まちが",
        "気持": "きもち",
        "山田": "やまだ",
        "図書館": "としょかん",
        "値段": "ねだん",
        "男前": "おとこまえ",
        "掃除": "そうじ",
        "一人": "ひとり",
        "一種": "いっしゅ",
        "朝寝坊": "あさねぼう",
        "今朝": "けさ",
        "荷物": "にもつ",
    },
    kanji: {
        "亜": "ア",
        "哀": "アイ",
        "挨": "アイ",
        "愛": "アイ",
        "曖": "アイ",
        "悪": "アク",
        "握": "アク",
        "圧": "アツ",
        "扱": "あつかう",
        "宛": "あてる",
        "嵐": "あらし",
        "安": "アン",
        "案": "アン",
        "暗": "アン",
        "以": "イ",
        "衣": "イ",
        "位": "イ",
        "囲": "イ",
        "医": "イ",
        "依": "イ",
        "委": "イ",
        "威": "イ",
        "胃": "イ",
        "為": "イ",
        "畏": "イ",
        "尉": "イ",
        "異": "イ",
        "移": "イ",
        "萎": "イ",
        "偉": "イ",
        "椅": "イ",
        "彙": "イ",
        "意": "イ",
        "違": "イ",
        "維": "イ",
        "慰": "イ",
        "遺": "イ",
        "緯": "イ",
        "域": "イキ",
        "育": "イク",
        "一": "イチ",
        "壱": "イチ",
        "逸": "イツ",
        "茨": "いばら",
        "芋": "いも",
        "引": "イン",
        "印": "イン",
        "因": "イン",
        "咽": "イン",
        "姻": "イン",
        "員": "イン",
        "院": "イン",
        "淫": "イン",
        "陰": "イン",
        "飲": "イン",
        "隠": "イン",
        "韻": "イン",
        "右": "ウ",
        "宇": "ウ",
        "羽": "ウ",
        "雨": "ウ",
        "唄": "うた",
        "鬱": "ウツ",
        "畝": "うね",
        "浦": "うら",
        "運": "ウン",
        "雲": "ウン",
        "永": "エイ",
        "泳": "エイ",
        "英": "エイ",
        "映": "エイ",
        "栄": "エイ",
        "営": "エイ",
        "詠": "エイ",
        "影": "エイ",
        "鋭": "エイ",
        "衛": "エイ",
        "易": "エキ",
        "疫": "エキ",
        "益": "エキ",
        "液": "エキ",
        "駅": "エキ",
        "悦": "エツ",
        "越": "エツ",
        "謁": "エツ",
        "閲": "エツ",
        "円": "エン",
        "延": "エン",
        "沿": "エン",
        "炎": "エン",
        "怨": "エン",
        "宴": "エン",
        "媛": "エン",
        "援": "エン",
        "園": "エン",
        "煙": "エン",
        "猿": "エン",
        "遠": "エン",
        "鉛": "エン",
        "塩": "エン",
        "演": "エン",
        "縁": "エン",
        "艶": "エン",
        "汚": "オ",
        "王": "オウ",
        "凹": "オウ",
        "央": "オウ",
        "応": "オウ",
        "往": "オウ",
        "押": "オウ",
        "旺": "オウ",
        "欧": "オウ",
        "殴": "オウ",
        "桜": "オウ",
        "翁": "オウ",
        "奥": "オウ",
        "横": "オウ",
        "岡": "おか",
        "屋": "オク",
        "億": "オク",
        "憶": "オク",
        "臆": "オク",
        "虞": "おそれ",
        "乙": "オツ",
        "俺": "おれ",
        "卸": "おろす",
        "音": "オン",
        "恩": "オン",
        "温": "オン",
        "穏": "オン",
        "下": "カ",
        "化": "カ",
        "火": "カ",
        "加": "カ",
        "可": "カ",
        "仮": "カ",
        "何": "カ",
        "花": "カ",
        "佳": "カ",
        "価": "カ",
        "果": "カ",
        "河": "カ",
        "苛": "カ",
        "科": "カ",
        "架": "カ",
        "夏": "カ",
        "家": "カ",
        "荷": "カ",
        "華": "カ",
        "菓": "カ",
        "貨": "カ",
        "渦": "カ",
        "過": "カ",
        "嫁": "カ",
        "暇": "カ",
        "禍": "カ",
        "靴": "カ",
        "寡": "カ",
        "歌": "カ",
        "箇": "カ",
        "稼": "カ",
        "課": "カ",
        "蚊": "か",
        "牙": "ガ",
        "瓦": "ガ",
        "我": "ガ",
        "画": "ガ",
        "芽": "ガ",
        "賀": "ガ",
        "雅": "ガ",
        "餓": "ガ",
        "介": "カイ",
        "回": "カイ",
        "灰": "カイ",
        "会": "カイ",
        "快": "カイ",
        "戒": "カイ",
        "改": "カイ",
        "怪": "カイ",
        "拐": "カイ",
        "悔": "カイ",
        "海": "カイ",
        "界": "カイ",
        "皆": "カイ",
        "械": "カイ",
        "絵": "カイ",
        "開": "カイ",
        "階": "カイ",
        "塊": "カイ",
        "楷": "カイ",
        "解": "カイ",
        "潰": "カイ",
        "壊": "カイ",
        "懐": "カイ",
        "諧": "カイ",
        "貝": "かい",
        "外": "ガイ",
        "劾": "ガイ",
        "害": "ガイ",
        "崖": "ガイ",
        "涯": "ガイ",
        "街": "ガイ",
        "慨": "ガイ",
        "蓋": "ガイ",
        "該": "ガイ",
        "概": "ガイ",
        "骸": "ガイ",
        "垣": "かき",
        "柿": "かき",
        "各": "カク",
        "角": "カク",
        "拡": "カク",
        "革": "カク",
        "格": "カク",
        "核": "カク",
        "殻": "カク",
        "郭": "カク",
        "覚": "カク",
        "較": "カク",
        "隔": "カク",
        "閣": "カク",
        "確": "カク",
        "獲": "カク",
        "嚇": "カク",
        "穫": "カク",
        "学": "ガク",
        "岳": "ガク",
        "楽": "ガク",
        "額": "ガク",
        "顎": "ガク",
        "掛": "かける",
        "潟": "かた",
        "括": "カツ",
        "活": "カツ",
        "喝": "カツ",
        "渇": "カツ",
        "割": "カツ",
        "葛": "カツ",
        "滑": "カツ",
        "褐": "カツ",
        "轄": "カツ",
        "且": "かつ",
        "株": "かぶ",
        "釜": "かま",
        "鎌": "かま",
        "刈": "かる",
        "干": "カン",
        "刊": "カン",
        "甘": "カン",
        "汗": "カン",
        "缶": "カン",
        "完": "カン",
        "肝": "カン",
        "官": "カン",
        "冠": "カン",
        "巻": "カン",
        "看": "カン",
        "陥": "カン",
        "乾": "カン",
        "勘": "カン",
        "患": "カン",
        "貫": "カン",
        "寒": "カン",
        "喚": "カン",
        "堪": "カン",
        "換": "カン",
        "敢": "カン",
        "棺": "カン",
        "款": "カン",
        "間": "カン",
        "閑": "カン",
        "勧": "カン",
        "寛": "カン",
        "幹": "カン",
        "感": "カン",
        "漢": "カン",
        "慣": "カン",
        "管": "カン",
        "関": "カン",
        "歓": "カン",
        "監": "カン",
        "緩": "カン",
        "憾": "カン",
        "還": "カン",
        "館": "カン",
        "環": "カン",
        "簡": "カン",
        "観": "カン",
        "韓": "カン",
        "艦": "カン",
        "鑑": "カン",
        "丸": "ガン",
        "含": "ガン",
        "岸": "ガン",
        "岩": "ガン",
        "玩": "ガン",
        "眼": "ガン",
        "頑": "ガン",
        "顔": "ガン",
        "願": "ガン",
        "企": "キ",
        "伎": "キ",
        "危": "キ",
        "机": "キ",
        "気": "キ",
        "岐": "キ",
        "希": "キ",
        "忌": "キ",
        "汽": "キ",
        "奇": "キ",
        "祈": "キ",
        "季": "キ",
        "紀": "キ",
        "軌": "キ",
        "既": "キ",
        "記": "キ",
        "起": "キ",
        "飢": "キ",
        "鬼": "キ",
        "帰": "キ",
        "基": "キ",
        "寄": "キ",
        "規": "キ",
        "亀": "キ",
        "喜": "キ",
        "幾": "キ",
        "揮": "キ",
        "期": "キ",
        "棋": "キ",
        "貴": "キ",
        "棄": "キ",
        "毀": "キ",
        "旗": "キ",
        "器": "キ",
        "畿": "キ",
        "輝": "キ",
        "機": "キ",
        "騎": "キ",
        "技": "ギ",
        "宜": "ギ",
        "偽": "ギ",
        "欺": "ギ",
        "義": "ギ",
        "疑": "ギ",
        "儀": "ギ",
        "戯": "ギ",
        "擬": "ギ",
        "犠": "ギ",
        "議": "ギ",
        "菊": "キク",
        "吉": "キチ",
        "喫": "キツ",
        "詰": "キツ",
        "却": "キャク",
        "客": "キャク",
        "脚": "キャク",
        "逆": "ギャク",
        "虐": "ギャク",
        "九": "キュウ",
        "久": "キュウ",
        "及": "キュウ",
        "弓": "キュウ",
        "丘": "キュウ",
        "旧": "キュウ",
        "休": "キュウ",
        "吸": "キュウ",
        "朽": "キュウ",
        "臼": "キュウ",
        "求": "キュウ",
        "究": "キュウ",
        "泣": "キュウ",
        "急": "キュウ",
        "級": "キュウ",
        "糾": "キュウ",
        "宮": "キュウ",
        "救": "キュウ",
        "球": "キュウ",
        "給": "キュウ",
        "嗅": "キュウ",
        "窮": "キュウ",
        "牛": "ギュウ",
        "去": "キョ",
        "巨": "キョ",
        "居": "キョ",
        "拒": "キョ",
        "拠": "キョ",
        "挙": "キョ",
        "虚": "キョ",
        "許": "キョ",
        "距": "キョ",
        "魚": "ギョ",
        "御": "ギョ",
        "漁": "ギョ",
        "凶": "キョウ",
        "共": "キョウ",
        "叫": "キョウ",
        "狂": "キョウ",
        "京": "キョウ",
        "享": "キョウ",
        "供": "キョウ",
        "協": "キョウ",
        "況": "キョウ",
        "峡": "キョウ",
        "挟": "キョウ",
        "狭": "キョウ",
        "恐": "キョウ",
        "恭": "キョウ",
        "胸": "キョウ",
        "脅": "キョウ",
        "強": "キョウ",
        "教": "キョウ",
        "郷": "キョウ",
        "境": "キョウ",
        "橋": "キョウ",
        "矯": "キョウ",
        "鏡": "キョウ",
        "競": "キョウ",
        "響": "キョウ",
        "驚": "キョウ",
        "仰": "ギョウ",
        "暁": "ギョウ",
        "業": "ギョウ",
        "凝": "ギョウ",
        "曲": "キョク",
        "局": "キョク",
        "極": "キョク",
        "玉": "ギョク",
        "巾": "キン",
        "斤": "キン",
        "均": "キン",
        "近": "キン",
        "金": "キン",
        "菌": "キン",
        "勤": "キン",
        "琴": "キン",
        "筋": "キン",
        "僅": "キン",
        "禁": "キン",
        "緊": "キン",
        "錦": "キン",
        "謹": "キン",
        "襟": "キン",
        "吟": "ギン",
        "銀": "ギン",
        "区": "ク",
        "句": "ク",
        "苦": "ク",
        "駆": "ク",
        "具": "グ",
        "惧": "グ",
        "愚": "グ",
        "空": "クウ",
        "偶": "グウ",
        "遇": "グウ",
        "隅": "グウ",
        "串": "くし",
        "屈": "クツ",
        "掘": "クツ",
        "窟": "クツ",
        "熊": "くま",
        "繰": "くる",
        "君": "クン",
        "訓": "クン",
        "勲": "クン",
        "薫": "クン",
        "軍": "グン",
        "郡": "グン",
        "群": "グン",
        "兄": "ケイ",
        "刑": "ケイ",
        "形": "ケイ",
        "系": "ケイ",
        "径": "ケイ",
        "茎": "ケイ",
        "係": "ケイ",
        "型": "ケイ",
        "契": "ケイ",
        "計": "ケイ",
        "恵": "ケイ",
        "啓": "ケイ",
        "掲": "ケイ",
        "渓": "ケイ",
        "経": "ケイ",
        "蛍": "ケイ",
        "敬": "ケイ",
        "景": "ケイ",
        "軽": "ケイ",
        "傾": "ケイ",
        "携": "ケイ",
        "継": "ケイ",
        "詣": "ケイ",
        "慶": "ケイ",
        "憬": "ケイ",
        "稽": "ケイ",
        "憩": "ケイ",
        "警": "ケイ",
        "鶏": "ケイ",
        "芸": "ゲイ",
        "迎": "ゲイ",
        "鯨": "ゲイ",
        "隙": "ゲキ",
        "劇": "ゲキ",
        "撃": "ゲキ",
        "激": "ゲキ",
        "桁": "けた",
        "欠": "ケツ",
        "穴": "ケツ",
        "血": "ケツ",
        "決": "ケツ",
        "結": "ケツ",
        "傑": "ケツ",
        "潔": "ケツ",
        "月": "ゲツ",
        "犬": "ケン",
        "件": "ケン",
        "見": "ケン",
        "券": "ケン",
        "肩": "ケン",
        "建": "ケン",
        "研": "ケン",
        "県": "ケン",
        "倹": "ケン",
        "兼": "ケン",
        "剣": "ケン",
        "拳": "ケン",
        "軒": "ケン",
        "健": "ケン",
        "険": "ケン",
        "圏": "ケン",
        "堅": "ケン",
        "検": "ケン",
        "嫌": "ケン",
        "献": "ケン",
        "絹": "ケン",
        "遣": "ケン",
        "権": "ケン",
        "憲": "ケン",
        "賢": "ケン",
        "謙": "ケン",
        "鍵": "ケン",
        "繭": "ケン",
        "顕": "ケン",
        "験": "ケン",
        "懸": "ケン",
        "元": "ゲン",
        "幻": "ゲン",
        "玄": "ゲン",
        "言": "ゲン",
        "弦": "ゲン",
        "限": "ゲン",
        "原": "ゲン",
        "現": "ゲン",
        "舷": "ゲン",
        "減": "ゲン",
        "源": "ゲン",
        "厳": "ゲン",
        "己": "コ",
        "戸": "コ",
        "古": "コ",
        "呼": "コ",
        "固": "コ",
        "股": "コ",
        "虎": "コ",
        "孤": "コ",
        "弧": "コ",
        "故": "コ",
        "枯": "コ",
        "個": "コ",
        "庫": "コ",
        "湖": "コ",
        "雇": "コ",
        "誇": "コ",
        "鼓": "コ",
        "錮": "コ",
        "顧": "コ",
        "五": "ゴ",
        "互": "ゴ",
        "午": "ゴ",
        "呉": "ゴ",
        "後": "ゴ",
        "娯": "ゴ",
        "悟": "ゴ",
        "碁": "ゴ",
        "語": "ゴ",
        "誤": "ゴ",
        "護": "ゴ",
        "口": "コウ",
        "工": "コウ",
        "公": "コウ",
        "勾": "コウ",
        "孔": "コウ",
        "功": "コウ",
        "巧": "コウ",
        "広": "コウ",
        "甲": "コウ",
        "交": "コウ",
        "光": "コウ",
        "向": "コウ",
        "后": "コウ",
        "好": "コウ",
        "江": "コウ",
        "考": "コウ",
        "行": "コウ",
        "坑": "コウ",
        "孝": "コウ",
        "抗": "コウ",
        "攻": "コウ",
        "更": "コウ",
        "効": "コウ",
        "幸": "コウ",
        "拘": "コウ",
        "肯": "コウ",
        "侯": "コウ",
        "厚": "コウ",
        "恒": "コウ",
        "洪": "コウ",
        "皇": "コウ",
        "紅": "コウ",
        "荒": "コウ",
        "郊": "コウ",
        "香": "コウ",
        "候": "コウ",
        "校": "コウ",
        "耕": "コウ",
        "航": "コウ",
        "貢": "コウ",
        "降": "コウ",
        "高": "コウ",
        "康": "コウ",
        "控": "コウ",
        "梗": "コウ",
        "黄": "コウ",
        "喉": "コウ",
        "慌": "コウ",
        "港": "コウ",
        "硬": "コウ",
        "絞": "コウ",
        "項": "コウ",
        "溝": "コウ",
        "鉱": "コウ",
        "構": "コウ",
        "綱": "コウ",
        "酵": "コウ",
        "稿": "コウ",
        "興": "コウ",
        "衡": "コウ",
        "鋼": "コウ",
        "講": "コウ",
        "購": "コウ",
        "乞": "こう",
        "号": "ゴウ",
        "合": "ゴウ",
        "拷": "ゴウ",
        "剛": "ゴウ",
        "傲": "ゴウ",
        "豪": "ゴウ",
        "克": "コク",
        "告": "コク",
        "谷": "コク",
        "刻": "コク",
        "国": "コク",
        "黒": "コク",
        "穀": "コク",
        "酷": "コク",
        "獄": "ゴク",
        "骨": "コツ",
        "駒": "こま",
        "込": "こむ",
        "頃": "ころ",
        "今": "コン",
        "困": "コン",
        "昆": "コン",
        "恨": "コン",
        "根": "コン",
        "婚": "コン",
        "混": "コン",
        "痕": "コン",
        "紺": "コン",
        "魂": "コン",
        "墾": "コン",
        "懇": "コン",
        "左": "サ",
        "佐": "サ",
        "沙": "サ",
        "査": "サ",
        "砂": "サ",
        "唆": "サ",
        "差": "サ",
        "詐": "サ",
        "鎖": "サ",
        "座": "ザ",
        "挫": "ザ",
        "才": "サイ",
        "再": "サイ",
        "災": "サイ",
        "妻": "サイ",
        "采": "サイ",
        "砕": "サイ",
        "宰": "サイ",
        "栽": "サイ",
        "彩": "サイ",
        "採": "サイ",
        "済": "サイ",
        "祭": "サイ",
        "斎": "サイ",
        "細": "サイ",
        "菜": "サイ",
        "最": "サイ",
        "裁": "サイ",
        "債": "サイ",
        "催": "サイ",
        "塞": "サイ",
        "歳": "サイ",
        "載": "サイ",
        "際": "サイ",
        "埼": "さい",
        "在": "ザイ",
        "材": "ザイ",
        "剤": "ザイ",
        "財": "ザイ",
        "罪": "ザイ",
        "崎": "さき",
        "作": "サク",
        "削": "サク",
        "昨": "サク",
        "柵": "サク",
        "索": "サク",
        "策": "サク",
        "酢": "サク",
        "搾": "サク",
        "錯": "サク",
        "咲": "さく",
        "冊": "サツ",
        "札": "サツ",
        "刷": "サツ",
        "刹": "サツ",
        "拶": "サツ",
        "殺": "サツ",
        "察": "サツ",
        "撮": "サツ",
        "擦": "サツ",
        "雑": "ザツ",
        "皿": "さら",
        "三": "サン",
        "山": "サン",
        "参": "サン",
        "桟": "サン",
        "蚕": "サン",
        "惨": "サン",
        "産": "サン",
        "傘": "サン",
        "散": "サン",
        "算": "サン",
        "酸": "サン",
        "賛": "サン",
        "残": "ザン",
        "斬": "ザン",
        "暫": "ザン",
        "士": "シ",
        "子": "シ",
        "支": "シ",
        "止": "シ",
        "氏": "シ",
        "仕": "シ",
        "史": "シ",
        "司": "シ",
        "四": "シ",
        "市": "シ",
        "矢": "シ",
        "旨": "シ",
        "死": "シ",
        "糸": "シ",
        "至": "シ",
        "伺": "シ",
        "志": "シ",
        "私": "シ",
        "使": "シ",
        "刺": "シ",
        "始": "シ",
        "姉": "シ",
        "枝": "シ",
        "祉": "シ",
        "肢": "シ",
        "姿": "シ",
        "思": "シ",
        "指": "シ",
        "施": "シ",
        "師": "シ",
        "恣": "シ",
        "紙": "シ",
        "脂": "シ",
        "視": "シ",
        "紫": "シ",
        "詞": "シ",
        "歯": "シ",
        "嗣": "シ",
        "試": "シ",
        "詩": "シ",
        "資": "シ",
        "飼": "シ",
        "誌": "シ",
        "雌": "シ",
        "摯": "シ",
        "賜": "シ",
        "諮": "シ",
        "示": "ジ",
        "字": "ジ",
        "寺": "ジ",
        "次": "ジ",
        "耳": "ジ",
        "自": "ジ",
        "似": "ジ",
        "児": "ジ",
        "事": "ジ",
        "侍": "ジ",
        "治": "ジ",
        "持": "ジ",
        "時": "ジ",
        "滋": "ジ",
        "慈": "ジ",
        "辞": "ジ",
        "磁": "ジ",
        "餌": "ジ",
        "璽": "ジ",
        "鹿": "しか",
        "式": "シキ",
        "識": "シキ",
        "軸": "ジク",
        "七": "シチ",
        "𠮟": "シツ",
        "失": "シツ",
        "室": "シツ",
        "疾": "シツ",
        "執": "シツ",
        "湿": "シツ",
        "嫉": "シツ",
        "漆": "シツ",
        "質": "シツ",
        "実": "ジツ",
        "芝": "しば",
        "写": "シャ",
        "社": "シャ",
        "車": "シャ",
        "舎": "シャ",
        "者": "シャ",
        "射": "シャ",
        "捨": "シャ",
        "赦": "シャ",
        "斜": "シャ",
        "煮": "シャ",
        "遮": "シャ",
        "謝": "シャ",
        "邪": "ジャ",
        "蛇": "ジャ",
        "尺": "シャク",
        "借": "シャク",
        "酌": "シャク",
        "釈": "シャク",
        "爵": "シャク",
        "若": "ジャク",
        "弱": "ジャク",
        "寂": "ジャク",
        "手": "シュ",
        "主": "シュ",
        "守": "シュ",
        "朱": "シュ",
        "取": "シュ",
        "狩": "シュ",
        "首": "シュ",
        "殊": "シュ",
        "珠": "シュ",
        "酒": "シュ",
        "腫": "シュ",
        "種": "シュ",
        "趣": "シュ",
        "寿": "ジュ",
        "受": "ジュ",
        "呪": "ジュ",
        "授": "ジュ",
        "需": "ジュ",
        "儒": "ジュ",
        "樹": "ジュ",
        "収": "シュウ",
        "囚": "シュウ",
        "州": "シュウ",
        "舟": "シュウ",
        "秀": "シュウ",
        "周": "シュウ",
        "宗": "シュウ",
        "拾": "シュウ",
        "秋": "シュウ",
        "臭": "シュウ",
        "修": "シュウ",
        "袖": "シュウ",
        "終": "シュウ",
        "羞": "シュウ",
        "習": "シュウ",
        "週": "シュウ",
        "就": "シュウ",
        "衆": "シュウ",
        "集": "シュウ",
        "愁": "シュウ",
        "酬": "シュウ",
        "醜": "シュウ",
        "蹴": "シュウ",
        "襲": "シュウ",
        "十": "ジュウ",
        "汁": "ジュウ",
        "充": "ジュウ",
        "住": "ジュウ",
        "柔": "ジュウ",
        "重": "ジュウ",
        "従": "ジュウ",
        "渋": "ジュウ",
        "銃": "ジュウ",
        "獣": "ジュウ",
        "縦": "ジュウ",
        "叔": "シュク",
        "祝": "シュク",
        "宿": "シュク",
        "淑": "シュク",
        "粛": "シュク",
        "縮": "シュク",
        "塾": "ジュク",
        "熟": "ジュク",
        "出": "シュツ",
        "述": "ジュツ",
        "術": "ジュツ",
        "俊": "シュン",
        "春": "シュン",
        "瞬": "シュン",
        "旬": "ジュン",
        "巡": "ジュン",
        "盾": "ジュン",
        "准": "ジュン",
        "殉": "ジュン",
        "純": "ジュン",
        "循": "ジュン",
        "順": "ジュン",
        "準": "ジュン",
        "潤": "ジュン",
        "遵": "ジュン",
        "処": "ショ",
        "初": "ショ",
        "所": "ショ",
        "書": "ショ",
        "庶": "ショ",
        "暑": "ショ",
        "署": "ショ",
        "緒": "ショ",
        "諸": "ショ",
        "女": "ジョ",
        "如": "ジョ",
        "助": "ジョ",
        "序": "ジョ",
        "叙": "ジョ",
        "徐": "ジョ",
        "除": "ジョ",
        "小": "ショウ",
        "升": "ショウ",
        "少": "ショウ",
        "召": "ショウ",
        "匠": "ショウ",
        "床": "ショウ",
        "抄": "ショウ",
        "肖": "ショウ",
        "尚": "ショウ",
        "招": "ショウ",
        "承": "ショウ",
        "昇": "ショウ",
        "松": "ショウ",
        "沼": "ショウ",
        "昭": "ショウ",
        "宵": "ショウ",
        "将": "ショウ",
        "消": "ショウ",
        "症": "ショウ",
        "祥": "ショウ",
        "称": "ショウ",
        "笑": "ショウ",
        "唱": "ショウ",
        "商": "ショウ",
        "渉": "ショウ",
        "章": "ショウ",
        "紹": "ショウ",
        "訟": "ショウ",
        "勝": "ショウ",
        "掌": "ショウ",
        "晶": "ショウ",
        "焼": "ショウ",
        "焦": "ショウ",
        "硝": "ショウ",
        "粧": "ショウ",
        "詔": "ショウ",
        "証": "ショウ",
        "象": "ショウ",
        "傷": "ショウ",
        "奨": "ショウ",
        "照": "ショウ",
        "詳": "ショウ",
        "彰": "ショウ",
        "障": "ショウ",
        "憧": "ショウ",
        "衝": "ショウ",
        "賞": "ショウ",
        "償": "ショウ",
        "礁": "ショウ",
        "鐘": "ショウ",
        "上": "ジョウ",
        "丈": "ジョウ",
        "冗": "ジョウ",
        "条": "ジョウ",
        "状": "ジョウ",
        "乗": "ジョウ",
        "城": "ジョウ",
        "浄": "ジョウ",
        "剰": "ジョウ",
        "常": "ジョウ",
        "情": "ジョウ",
        "場": "ジョウ",
        "畳": "ジョウ",
        "蒸": "ジョウ",
        "縄": "ジョウ",
        "壌": "ジョウ",
        "嬢": "ジョウ",
        "錠": "ジョウ",
        "譲": "ジョウ",
        "醸": "ジョウ",
        "色": "ショク",
        "拭": "ショク",
        "食": "ショク",
        "植": "ショク",
        "殖": "ショク",
        "飾": "ショク",
        "触": "ショク",
        "嘱": "ショク",
        "織": "ショク",
        "職": "ショク",
        "辱": "ジョク",
        "尻": "しり",
        "心": "シン",
        "申": "シン",
        "伸": "シン",
        "臣": "シン",
        "芯": "シン",
        "身": "シン",
        "辛": "シン",
        "侵": "シン",
        "信": "シン",
        "津": "シン",
        "神": "シン",
        "唇": "シン",
        "娠": "シン",
        "振": "シン",
        "浸": "シン",
        "真": "シン",
        "針": "シン",
        "深": "シン",
        "紳": "シン",
        "進": "シン",
        "森": "シン",
        "診": "シン",
        "寝": "シン",
        "慎": "シン",
        "新": "シン",
        "審": "シン",
        "震": "シン",
        "薪": "シン",
        "親": "シン",
        "人": "ジン",
        "刃": "ジン",
        "仁": "ジン",
        "尽": "ジン",
        "迅": "ジン",
        "甚": "ジン",
        "陣": "ジン",
        "尋": "ジン",
        "腎": "ジン",
        "須": "ス",
        "図": "ズ",
        "水": "スイ",
        "吹": "スイ",
        "垂": "スイ",
        "炊": "スイ",
        "帥": "スイ",
        "粋": "スイ",
        "衰": "スイ",
        "推": "スイ",
        "酔": "スイ",
        "遂": "スイ",
        "睡": "スイ",
        "穂": "スイ",
        "随": "ズイ",
        "髄": "ズイ",
        "枢": "スウ",
        "崇": "スウ",
        "数": "スウ",
        "据": "すえる",
        "杉": "すぎ",
        "裾": "すそ",
        "寸": "スン",
        "瀬": "せ",
        "是": "ゼ",
        "井": "セイ",
        "世": "セイ",
        "正": "セイ",
        "生": "セイ",
        "成": "セイ",
        "西": "セイ",
        "声": "セイ",
        "制": "セイ",
        "姓": "セイ",
        "征": "セイ",
        "性": "セイ",
        "青": "セイ",
        "斉": "セイ",
        "政": "セイ",
        "星": "セイ",
        "牲": "セイ",
        "省": "セイ",
        "凄": "セイ",
        "逝": "セイ",
        "清": "セイ",
        "盛": "セイ",
        "婿": "セイ",
        "晴": "セイ",
        "勢": "セイ",
        "聖": "セイ",
        "誠": "セイ",
        "精": "セイ",
        "製": "セイ",
        "誓": "セイ",
        "静": "セイ",
        "請": "セイ",
        "整": "セイ",
        "醒": "セイ",
        "税": "ゼイ",
        "夕": "セキ",
        "斥": "セキ",
        "石": "セキ",
        "赤": "セキ",
        "昔": "セキ",
        "析": "セキ",
        "席": "セキ",
        "脊": "セキ",
        "隻": "セキ",
        "惜": "セキ",
        "戚": "セキ",
        "責": "セキ",
        "跡": "セキ",
        "積": "セキ",
        "績": "セキ",
        "籍": "セキ",
        "切": "セツ",
        "折": "セツ",
        "拙": "セツ",
        "窃": "セツ",
        "接": "セツ",
        "設": "セツ",
        "雪": "セツ",
        "摂": "セツ",
        "節": "セツ",
        "説": "セツ",
        "舌": "ゼツ",
        "絶": "ゼツ",
        "千": "セン",
        "川": "セン",
        "仙": "セン",
        "占": "セン",
        "先": "セン",
        "宣": "セン",
        "専": "セン",
        "泉": "セン",
        "浅": "セン",
        "洗": "セン",
        "染": "セン",
        "扇": "セン",
        "栓": "セン",
        "旋": "セン",
        "船": "セン",
        "戦": "セン",
        "煎": "セン",
        "羨": "セン",
        "腺": "セン",
        "詮": "セン",
        "践": "セン",
        "箋": "セン",
        "銭": "セン",
        "潜": "セン",
        "線": "セン",
        "遷": "セン",
        "選": "セン",
        "薦": "セン",
        "繊": "セン",
        "鮮": "セン",
        "全": "ゼン",
        "前": "ゼン",
        "善": "ゼン",
        "然": "ゼン",
        "禅": "ゼン",
        "漸": "ゼン",
        "膳": "ゼン",
        "繕": "ゼン",
        "狙": "ソ",
        "阻": "ソ",
        "祖": "ソ",
        "租": "ソ",
        "素": "ソ",
        "措": "ソ",
        "粗": "ソ",
        "組": "ソ",
        "疎": "ソ",
        "訴": "ソ",
        "塑": "ソ",
        "遡": "ソ",
        "礎": "ソ",
        "双": "ソウ",
        "壮": "ソウ",
        "早": "ソウ",
        "争": "ソウ",
        "走": "ソウ",
        "奏": "ソウ",
        "相": "ソウ",
        "荘": "ソウ",
        "草": "ソウ",
        "送": "ソウ",
        "倉": "ソウ",
        "捜": "ソウ",
        "挿": "ソウ",
        "桑": "ソウ",
        "掃": "ソウ",
        "曹": "ソウ",
        "曽": "ソウ",
        "爽": "ソウ",
        "巣": "ソウ",
        "窓": "ソウ",
        "創": "ソウ",
        "喪": "ソウ",
        "痩": "ソウ",
        "葬": "ソウ",
        "装": "ソウ",
        "僧": "ソウ",
        "想": "ソウ",
        "層": "ソウ",
        "総": "ソウ",
        "遭": "ソウ",
        "槽": "ソウ",
        "踪": "ソウ",
        "操": "ソウ",
        "燥": "ソウ",
        "霜": "ソウ",
        "騒": "ソウ",
        "藻": "ソウ",
        "造": "ゾウ",
        "像": "ゾウ",
        "増": "ゾウ",
        "憎": "ゾウ",
        "蔵": "ゾウ",
        "贈": "ゾウ",
        "臓": "ゾウ",
        "即": "ソク",
        "束": "ソク",
        "足": "ソク",
        "促": "ソク",
        "則": "ソク",
        "息": "ソク",
        "捉": "ソク",
        "速": "ソク",
        "側": "ソク",
        "測": "ソク",
        "俗": "ゾク",
        "族": "ゾク",
        "属": "ゾク",
        "賊": "ゾク",
        "続": "ゾク",
        "卒": "ソツ",
        "率": "ソツ",
        "存": "ソン",
        "村": "ソン",
        "孫": "ソン",
        "尊": "ソン",
        "損": "ソン",
        "遜": "ソン",
        "他": "タ",
        "多": "タ",
        "汰": "タ",
        "打": "ダ",
        "妥": "ダ",
        "唾": "ダ",
        "堕": "ダ",
        "惰": "ダ",
        "駄": "ダ",
        "太": "タイ",
        "対": "タイ",
        "体": "タイ",
        "耐": "タイ",
        "待": "タイ",
        "怠": "タイ",
        "胎": "タイ",
        "退": "タイ",
        "帯": "タイ",
        "泰": "タイ",
        "堆": "タイ",
        "袋": "タイ",
        "逮": "タイ",
        "替": "タイ",
        "貸": "タイ",
        "隊": "タイ",
        "滞": "タイ",
        "態": "タイ",
        "戴": "タイ",
        "大": "ダイ",
        "代": "ダイ",
        "台": "ダイ",
        "第": "ダイ",
        "題": "ダイ",
        "滝": "たき",
        "宅": "タク",
        "択": "タク",
        "沢": "タク",
        "卓": "タク",
        "拓": "タク",
        "託": "タク",
        "濯": "タク",
        "諾": "ダク",
        "濁": "ダク",
        "但": "ただし",
        "達": "タツ",
        "脱": "ダツ",
        "奪": "ダツ",
        "棚": "たな",
        "誰": "だれ",
        "丹": "タン",
        "旦": "タン",
        "担": "タン",
        "単": "タン",
        "炭": "タン",
        "胆": "タン",
        "探": "タン",
        "淡": "タン",
        "短": "タン",
        "嘆": "タン",
        "端": "タン",
        "綻": "タン",
        "誕": "タン",
        "鍛": "タン",
        "団": "ダン",
        "男": "ダン",
        "段": "ダン",
        "断": "ダン",
        "弾": "ダン",
        "暖": "ダン",
        "談": "ダン",
        "壇": "ダン",
        "地": "チ",
        "池": "チ",
        "知": "チ",
        "値": "チ",
        "恥": "チ",
        "致": "チ",
        "遅": "チ",
        "痴": "チ",
        "稚": "チ",
        "置": "チ",
        "緻": "チ",
        "竹": "チク",
        "畜": "チク",
        "逐": "チク",
        "蓄": "チク",
        "築": "チク",
        "秩": "チツ",
        "窒": "チツ",
        "茶": "チャ",
        "着": "チャク",
        "嫡": "チャク",
        "中": "チュウ",
        "仲": "チュウ",
        "虫": "チュウ",
        "沖": "チュウ",
        "宙": "チュウ",
        "忠": "チュウ",
        "抽": "チュウ",
        "注": "チュウ",
        "昼": "チュウ",
        "柱": "チュウ",
        "衷": "チュウ",
        "酎": "チュウ",
        "鋳": "チュウ",
        "駐": "チュウ",
        "著": "チョ",
        "貯": "チョ",
        "丁": "チョウ",
        "弔": "チョウ",
        "庁": "チョウ",
        "兆": "チョウ",
        "町": "チョウ",
        "長": "チョウ",
        "挑": "チョウ",
        "帳": "チョウ",
        "張": "チョウ",
        "彫": "チョウ",
        "眺": "チョウ",
        "釣": "チョウ",
        "頂": "チョウ",
        "鳥": "チョウ",
        "朝": "チョウ",
        "貼": "チョウ",
        "超": "チョウ",
        "腸": "チョウ",
        "跳": "チョウ",
        "徴": "チョウ",
        "嘲": "チョウ",
        "潮": "チョウ",
        "澄": "チョウ",
        "調": "チョウ",
        "聴": "チョウ",
        "懲": "チョウ",
        "直": "チョク",
        "勅": "チョク",
        "捗": "チョク",
        "沈": "チン",
        "珍": "チン",
        "朕": "チン",
        "陳": "チン",
        "賃": "チン",
        "鎮": "チン",
        "追": "ツイ",
        "椎": "ツイ",
        "墜": "ツイ",
        "通": "ツウ",
        "痛": "ツウ",
        "塚": "つか",
        "漬": "つける",
        "坪": "つぼ",
        "爪": "つめ",
        "鶴": "つる",
        "低": "テイ",
        "呈": "テイ",
        "廷": "テイ",
        "弟": "テイ",
        "定": "テイ",
        "底": "テイ",
        "抵": "テイ",
        "邸": "テイ",
        "亭": "テイ",
        "貞": "テイ",
        "帝": "テイ",
        "訂": "テイ",
        "庭": "テイ",
        "逓": "テイ",
        "停": "テイ",
        "偵": "テイ",
        "堤": "テイ",
        "提": "テイ",
        "程": "テイ",
        "艇": "テイ",
        "締": "テイ",
        "諦": "テイ",
        "泥": "デイ",
        "的": "テキ",
        "笛": "テキ",
        "摘": "テキ",
        "滴": "テキ",
        "適": "テキ",
        "敵": "テキ",
        "溺": "デキ",
        "迭": "テツ",
        "哲": "テツ",
        "鉄": "テツ",
        "徹": "テツ",
        "撤": "テツ",
        "天": "テン",
        "典": "テン",
        "店": "テン",
        "点": "テン",
        "展": "テン",
        "添": "テン",
        "転": "テン",
        "塡": "テン",
        "田": "デン",
        "伝": "デン",
        "殿": "デン",
        "電": "デン",
        "斗": "ト",
        "吐": "ト",
        "妬": "ト",
        "徒": "ト",
        "途": "ト",
        "都": "ト",
        "渡": "ト",
        "塗": "ト",
        "賭": "ト",
        "土": "ド",
        "奴": "ド",
        "努": "ド",
        "度": "ド",
        "怒": "ド",
        "刀": "トウ",
        "冬": "トウ",
        "灯": "トウ",
        "当": "トウ",
        "投": "トウ",
        "豆": "トウ",
        "東": "トウ",
        "到": "トウ",
        "逃": "トウ",
        "倒": "トウ",
        "凍": "トウ",
        "唐": "トウ",
        "島": "トウ",
        "桃": "トウ",
        "討": "トウ",
        "透": "トウ",
        "党": "トウ",
        "悼": "トウ",
        "盗": "トウ",
        "陶": "トウ",
        "塔": "トウ",
        "搭": "トウ",
        "棟": "トウ",
        "湯": "トウ",
        "痘": "トウ",
        "登": "トウ",
        "答": "トウ",
        "等": "トウ",
        "筒": "トウ",
        "統": "トウ",
        "稲": "トウ",
        "踏": "トウ",
        "糖": "トウ",
        "頭": "トウ",
        "謄": "トウ",
        "藤": "トウ",
        "闘": "トウ",
        "騰": "トウ",
        "同": "ドウ",
        "洞": "ドウ",
        "胴": "ドウ",
        "動": "ドウ",
        "堂": "ドウ",
        "童": "ドウ",
        "道": "ドウ",
        "働": "ドウ",
        "銅": "ドウ",
        "導": "ドウ",
        "瞳": "ドウ",
        "峠": "とうげ",
        "匿": "トク",
        "特": "トク",
        "得": "トク",
        "督": "トク",
        "徳": "トク",
        "篤": "トク",
        "毒": "ドク",
        "独": "ドク",
        "読": "ドク",
        "栃": "とち",
        "凸": "トツ",
        "突": "トツ",
        "届": "とどける",
        "屯": "トン",
        "豚": "トン",
        "頓": "トン",
        "貪": "ドン",
        "鈍": "ドン",
        "曇": "ドン",
        "丼": "どんぶり",
        "那": "ナ",
        "奈": "ナ",
        "内": "ナイ",
        "梨": "なし",
        "謎": "なぞ",
        "鍋": "なべ",
        "南": "ナン",
        "軟": "ナン",
        "難": "ナン",
        "二": "ニ",
        "尼": "ニ",
        "弐": "ニ",
        "匂": "におう",
        "肉": "ニク",
        "虹": "にじ",
        "日": "ニチ",
        "入": "ニュウ",
        "乳": "ニュウ",
        "尿": "ニョウ",
        "任": "ニン",
        "妊": "ニン",
        "忍": "ニン",
        "認": "ニン",
        "寧": "ネイ",
        "熱": "ネツ",
        "年": "ネン",
        "念": "ネン",
        "捻": "ネン",
        "粘": "ネン",
        "燃": "ネン",
        "悩": "ノウ",
        "納": "ノウ",
        "能": "ノウ",
        "脳": "ノウ",
        "農": "ノウ",
        "濃": "ノウ",
        "把": "ハ",
        "波": "ハ",
        "派": "ハ",
        "破": "ハ",
        "覇": "ハ",
        "馬": "バ",
        "婆": "バ",
        "罵": "バ",
        "拝": "ハイ",
        "杯": "ハイ",
        "背": "ハイ",
        "肺": "ハイ",
        "俳": "ハイ",
        "配": "ハイ",
        "排": "ハイ",
        "敗": "ハイ",
        "廃": "ハイ",
        "輩": "ハイ",
        "売": "バイ",
        "倍": "バイ",
        "梅": "バイ",
        "培": "バイ",
        "陪": "バイ",
        "媒": "バイ",
        "買": "バイ",
        "賠": "バイ",
        "白": "ハク",
        "伯": "ハク",
        "拍": "ハク",
        "泊": "ハク",
        "迫": "ハク",
        "剝": "ハク",
        "舶": "ハク",
        "博": "ハク",
        "薄": "ハク",
        "麦": "バク",
        "漠": "バク",
        "縛": "バク",
        "爆": "バク",
        "箱": "はこ",
        "箸": "はし",
        "畑": "はた",
        "肌": "はだ",
        "八": "ハチ",
        "鉢": "ハチ",
        "発": "ハツ",
        "髪": "ハツ",
        "伐": "バツ",
        "抜": "バツ",
        "罰": "バツ",
        "閥": "バツ",
        "反": "ハン",
        "半": "ハン",
        "氾": "ハン",
        "犯": "ハン",
        "帆": "ハン",
        "汎": "ハン",
        "伴": "ハン",
        "判": "ハン",
        "坂": "ハン",
        "阪": "ハン",
        "板": "ハン",
        "版": "ハン",
        "班": "ハン",
        "畔": "ハン",
        "般": "ハン",
        "販": "ハン",
        "斑": "ハン",
        "飯": "ハン",
        "搬": "ハン",
        "煩": "ハン",
        "頒": "ハン",
        "範": "ハン",
        "繁": "ハン",
        "藩": "ハン",
        "晩": "バン",
        "番": "バン",
        "蛮": "バン",
        "盤": "バン",
        "比": "ヒ",
        "皮": "ヒ",
        "妃": "ヒ",
        "否": "ヒ",
        "批": "ヒ",
        "彼": "ヒ",
        "披": "ヒ",
        "肥": "ヒ",
        "非": "ヒ",
        "卑": "ヒ",
        "飛": "ヒ",
        "疲": "ヒ",
        "秘": "ヒ",
        "被": "ヒ",
        "悲": "ヒ",
        "扉": "ヒ",
        "費": "ヒ",
        "碑": "ヒ",
        "罷": "ヒ",
        "避": "ヒ",
        "尾": "ビ",
        "眉": "ビ",
        "美": "ビ",
        "備": "ビ",
        "微": "ビ",
        "鼻": "ビ",
        "膝": "ひざ",
        "肘": "ひじ",
        "匹": "ヒツ",
        "必": "ヒツ",
        "泌": "ヒツ",
        "筆": "ヒツ",
        "姫": "ひめ",
        "百": "ヒャク",
        "氷": "ヒョウ",
        "表": "ヒョウ",
        "俵": "ヒョウ",
        "票": "ヒョウ",
        "評": "ヒョウ",
        "漂": "ヒョウ",
        "標": "ヒョウ",
        "苗": "ビョウ",
        "秒": "ビョウ",
        "病": "ビョウ",
        "描": "ビョウ",
        "猫": "ビョウ",
        "品": "ヒン",
        "浜": "ヒン",
        "貧": "ヒン",
        "賓": "ヒン",
        "頻": "ヒン",
        "敏": "ビン",
        "瓶": "ビン",
        "不": "フ",
        "夫": "フ",
        "父": "フ",
        "付": "フ",
        "布": "フ",
        "扶": "フ",
        "府": "フ",
        "怖": "フ",
        "附": "フ",
        "阜": "フ",
        "訃": "フ",
        "負": "フ",
        "赴": "フ",
        "浮": "フ",
        "婦": "フ",
        "符": "フ",
        "富": "フ",
        "普": "フ",
        "腐": "フ",
        "敷": "フ",
        "膚": "フ",
        "賦": "フ",
        "譜": "フ",
        "侮": "ブ",
        "武": "ブ",
        "部": "ブ",
        "舞": "ブ",
        "封": "フウ",
        "風": "フウ",
        "伏": "フク",
        "服": "フク",
        "副": "フク",
        "幅": "フク",
        "復": "フク",
        "福": "ふく",
        "腹": "フク",
        "複": "フク",
        "覆": "フク",
        "払": "フツ",
        "沸": "フツ",
        "仏": "ブツ",
        "物": "ブツ",
        "粉": "フン",
        "紛": "フン",
        "雰": "フン",
        "噴": "フン",
        "墳": "フン",
        "憤": "フン",
        "奮": "フン",
        "分": "ブン",
        "文": "ブン",
        "聞": "ブン",
        "丙": "ヘイ",
        "平": "ヘイ",
        "兵": "ヘイ",
        "併": "ヘイ",
        "並": "ヘイ",
        "柄": "ヘイ",
        "陛": "ヘイ",
        "閉": "ヘイ",
        "塀": "ヘイ",
        "幣": "ヘイ",
        "弊": "ヘイ",
        "蔽": "ヘイ",
        "餅": "ヘイ",
        "米": "ベイ",
        "壁": "ヘキ",
        "璧": "ヘキ",
        "癖": "ヘキ",
        "別": "ベツ",
        "蔑": "ベツ",
        "片": "ヘン",
        "辺": "ヘン",
        "返": "ヘン",
        "変": "ヘン",
        "偏": "ヘン",
        "遍": "ヘン",
        "編": "ヘン",
        "弁": "ベン",
        "便": "ベン",
        "勉": "ベン",
        "歩": "ホ",
        "保": "ホ",
        "哺": "ホ",
        "捕": "ホ",
        "補": "ホ",
        "舗": "ホ",
        "母": "ボ",
        "募": "ボ",
        "墓": "ボ",
        "慕": "ボ",
        "暮": "ボ",
        "簿": "ボ",
        "方": "ホウ",
        "包": "ホウ",
        "芳": "ホウ",
        "邦": "ホウ",
        "奉": "ホウ",
        "宝": "ホウ",
        "抱": "ホウ",
        "放": "ホウ",
        "法": "ホウ",
        "泡": "ホウ",
        "胞": "ホウ",
        "俸": "ホウ",
        "倣": "ホウ",
        "峰": "ホウ",
        "砲": "ホウ",
        "崩": "ホウ",
        "訪": "ホウ",
        "報": "ホウ",
        "蜂": "ホウ",
        "豊": "ホウ",
        "飽": "ホウ",
        "褒": "ホウ",
        "縫": "ホウ",
        "亡": "ボウ",
        "乏": "ボウ",
        "忙": "ボウ",
        "坊": "ボウ",
        "妨": "ボウ",
        "忘": "ボウ",
        "防": "ボウ",
        "房": "ボウ",
        "肪": "ボウ",
        "某": "ボウ",
        "冒": "ボウ",
        "剖": "ボウ",
        "紡": "ボウ",
        "望": "ボウ",
        "傍": "ボウ",
        "帽": "ボウ",
        "棒": "ボウ",
        "貿": "ボウ",
        "貌": "ボウ",
        "暴": "ボウ",
        "膨": "ボウ",
        "謀": "ボウ",
        "頰": "ほお",
        "北": "ホク",
        "木": "ボク",
        "朴": "ボク",
        "牧": "ボク",
        "睦": "ボク",
        "僕": "ボク",
        "墨": "ボク",
        "撲": "ボク",
        "没": "ボツ",
        "勃": "ボツ",
        "堀": "ほり",
        "本": "ホン",
        "奔": "ホン",
        "翻": "ホン",
        "凡": "ボン",
        "盆": "ボン",
        "麻": "マ",
        "摩": "マ",
        "磨": "マ",
        "魔": "マ",
        "毎": "マイ",
        "妹": "マイ",
        "枚": "マイ",
        "昧": "マイ",
        "埋": "マイ",
        "幕": "マク",
        "膜": "マク",
        "枕": "まくら",
        "又": "また",
        "末": "マツ",
        "抹": "マツ",
        "万": "マン",
        "満": "マン",
        "慢": "マン",
        "漫": "マン",
        "未": "ミ",
        "味": "ミ",
        "魅": "ミ",
        "岬": "みさき",
        "密": "ミツ",
        "蜜": "ミツ",
        "脈": "ミャク",
        "妙": "ミョウ",
        "民": "ミン",
        "眠": "ミン",
        "矛": "ム",
        "務": "ム",
        "無": "ム",
        "夢": "ム",
        "霧": "ム",
        "娘": "むすめ",
        "名": "メイ",
        "命": "メイ",
        "明": "メイ",
        "迷": "メイ",
        "冥": "メイ",
        "盟": "メイ",
        "銘": "メイ",
        "鳴": "メイ",
        "滅": "メツ",
        "免": "メン",
        "面": "メン",
        "綿": "メン",
        "麺": "メン",
        "茂": "モ",
        "模": "モ",
        "毛": "モウ",
        "妄": "モウ",
        "盲": "モウ",
        "耗": "モウ",
        "猛": "モウ",
        "網": "モウ",
        "目": "モク",
        "黙": "モク",
        "門": "モン",
        "紋": "モン",
        "問": "モン",
        "冶": "ヤ",
        "夜": "ヤ",
        "野": "ヤ",
        "弥": "ヤ",
        "厄": "ヤク",
        "役": "ヤク",
        "約": "ヤク",
        "訳": "ヤク",
        "薬": "ヤク",
        "躍": "ヤク",
        "闇": "やみ",
        "由": "ユ",
        "油": "ユ",
        "喩": "ユ",
        "愉": "ユ",
        "諭": "ユ",
        "輸": "ユ",
        "癒": "ユ",
        "唯": "ユイ",
        "友": "ユウ",
        "有": "ユウ",
        "勇": "ユウ",
        "幽": "ユウ",
        "悠": "ユウ",
        "郵": "ユウ",
        "湧": "ユウ",
        "猶": "ユウ",
        "裕": "ユウ",
        "遊": "ユウ",
        "雄": "ユウ",
        "誘": "ユウ",
        "憂": "ユウ",
        "融": "ユウ",
        "優": "ユウ",
        "与": "ヨ",
        "予": "ヨ",
        "余": "ヨ",
        "誉": "ヨ",
        "預": "ヨ",
        "幼": "ヨウ",
        "用": "ヨウ",
        "羊": "ヨウ",
        "妖": "ヨウ",
        "洋": "ヨウ",
        "要": "ヨウ",
        "容": "ヨウ",
        "庸": "ヨウ",
        "揚": "ヨウ",
        "揺": "ヨウ",
        "葉": "ヨウ",
        "陽": "ヨウ",
        "溶": "ヨウ",
        "腰": "ヨウ",
        "様": "ヨウ",
        "瘍": "ヨウ",
        "踊": "ヨウ",
        "窯": "ヨウ",
        "養": "ヨウ",
        "擁": "ヨウ",
        "謡": "ヨウ",
        "曜": "ヨウ",
        "抑": "ヨク",
        "沃": "ヨク",
        "浴": "ヨク",
        "欲": "ヨク",
        "翌": "ヨク",
        "翼": "ヨク",
        "拉": "ラ",
        "裸": "ラ",
        "羅": "ラ",
        "来": "ライ",
        "雷": "ライ",
        "頼": "ライ",
        "絡": "ラク",
        "落": "ラク",
        "酪": "ラク",
        "辣": "ラツ",
        "乱": "ラン",
        "卵": "ラン",
        "覧": "ラン",
        "濫": "ラン",
        "藍": "ラン",
        "欄": "ラン",
        "吏": "リ",
        "利": "リ",
        "里": "リ",
        "理": "リ",
        "痢": "リ",
        "裏": "リ",
        "履": "リ",
        "璃": "リ",
        "離": "リ",
        "陸": "リク",
        "立": "リツ",
        "律": "リツ",
        "慄": "リツ",
        "略": "リャク",
        "柳": "リュウ",
        "流": "リュウ",
        "留": "リュウ",
        "竜": "リュウ",
        "粒": "リュウ",
        "隆": "リュウ",
        "硫": "リュウ",
        "侶": "リョ",
        "旅": "リョ",
        "虜": "リョ",
        "慮": "リョ",
        "了": "リョウ",
        "両": "リョウ",
        "良": "リョウ",
        "料": "リョウ",
        "涼": "リョウ",
        "猟": "リョウ",
        "陵": "リョウ",
        "量": "リョウ",
        "僚": "リョウ",
        "領": "リョウ",
        "寮": "リョウ",
        "療": "リョウ",
        "瞭": "リョウ",
        "糧": "リョウ",
        "力": "リョク",
        "緑": "リョク",
        "林": "リン",
        "厘": "リン",
        "倫": "リン",
        "輪": "リン",
        "隣": "リン",
        "臨": "リン",
        "瑠": "ル",
        "涙": "ルイ",
        "累": "ルイ",
        "塁": "ルイ",
        "類": "ルイ",
        "令": "レイ",
        "礼": "レイ",
        "冷": "レイ",
        "励": "レイ",
        "戻": "レイ",
        "例": "レイ",
        "鈴": "レイ",
        "零": "レイ",
        "霊": "レイ",
        "隷": "レイ",
        "齢": "レイ",
        "麗": "レイ",
        "暦": "レキ",
        "歴": "レキ",
        "列": "レツ",
        "劣": "レツ",
        "烈": "レツ",
        "裂": "レツ",
        "恋": "レン",
        "連": "レン",
        "廉": "レン",
        "練": "レン",
        "錬": "レン",
        "呂": "ロ",
        "炉": "ロ",
        "賂": "ロ",
        "路": "ロ",
        "露": "ロ",
        "老": "ロウ",
        "労": "ロウ",
        "弄": "ロウ",
        "郎": "ロウ",
        "朗": "ロウ",
        "浪": "ロウ",
        "廊": "ロウ",
        "楼": "ロウ",
        "漏": "ロウ",
        "籠": "ロウ",
        "六": "ロク",
        "録": "ロク",
        "麓": "ロク",
        "論": "ロン",
        "和": "ワ",
        "話": "ワ",
        "賄": "ワイ",
        "脇": "わき",
        "惑": "ワク",
        "枠": "わく",
        "湾": "ワン",
        "腕": "ワン",

    },
    hiragana:
    {
        "哀": "あわ",
        "悪": "わる",
        "握": "にぎ",
        "扱": "あつか",
        "宛": "あ",
        "安": "やす",
        "暗": "くら",
        "囲": "かこ",
        "委": "ゆだ",
        "畏": "おそ",
        "移": "うつ",
        "萎": "な",
        "偉": "えら",
        "違": "ちが",
        "慰": "なぐさ",
        "育む": "はぐくむ",
        "育み": "はぐくみ",
        "育んで": "はぐくんで",
        "育": "そだ",
        "一つ": "ひとつ",
        "引": "ひ",
        "因": "よ",
        "淫": "み",
        "陰": "かげ",
        "飲": "の",
        "隠": "かく",
        "運": "はこ",
        "永": "なが",
        "泳": "およ",
        "映え": "はえ",
        "映": "うつ",
        "栄え": "さかえ",
        "栄": "は",
        "営": "いとな",
        "詠": "よ",
        "鋭": "するど",
        "易": "やさ",
        "越": "こ",
        "円": "まる",
        "延": "の",
        "沿": "そ",
        "煙": "けむ",
        "遠": "とお",
        "汚れ": "よごれ",
        "汚": "きたな",
        "応": "おう",
        "押": "お",
        "殴": "なぐ",
        "卸": "おろ",
        "温": "あたた",
        "穏": "おだ",
        "下げ": "さげ",
        "下が": "さが",
        "下ろ": "おろ",
        "下": "くだ",
        "化": "ば",
        "加": "くわ",
        "果": "は",
        "架": "か",
        "過ご": "すご",
        "過ぎ": "すぎ",
        "過": "あやま",
        "嫁": "とつ",
        "歌": "うた",
        "稼": "かせ",
        "回": "まわ",
        "会": "あ",
        "快": "こころよ",
        "戒": "いまし",
        "改": "あらた",
        "怪": "あや",
        "悔し": "くやし",
        "悔": "く",
        "開": "ひら",
        "解": "と",
        "潰": "つぶ",
        "壊": "こわ",
        "懐": "なつ",
        "外": "はず",
        "覚え": "おぼえ",
        "覚": "さ",
        "隔": "へだ",
        "確": "たし",
        "獲": "え",
        "学": "まな",
        "楽": "たの",
        "掛": "か",
        "渇": "かわ",
        "割く": "さく",
        "割き": "さき",
        "割いて": "割いて",
        "割": "わ",
        "滑ら": "なめら",
        "滑": "すべ",
        "且": "か",
        "刈": "か",
        "干": "ほ",
        "甘": "あま",
        "巻": "ま",
        "陥れ": "おとしいれ",
        "陥": "おちい",
        "乾": "かわ",
        "患": "わずら",
        "貫": "つらぬ",
        "寒": "さむ",
        "堪": "た",
        "換": "か",
        "勧": "すす",
        "慣": "な",
        "関": "かん",
        "緩": "ゆる",
        "鑑": "かんが",
        "丸": "まる",
        "含": "ふく",
        "願": "ねが",
        "企": "くわだ",
        "危な": "あぶな",
        "危": "あや",
        "忌": "い",
        "祈": "いの",
        "既": "すで",
        "記": "しる",
        "起": "お",
        "飢": "う",
        "帰": "かえ",
        "寄": "よ",
        "喜": "よろこ",
        "貴": "とうと",
        "輝": "かがや",
        "偽": "いつわ",
        "欺": "あざむ",
        "疑": "うたが",
        "戯": "たわむ",
        "詰": "つ",
        "逆": "さか",
        "虐": "しいた",
        "九": "ここの",
        "久": "ひさ",
        "及": "およ",
        "休": "やす",
        "吸": "す",
        "朽": "く",
        "求": "もと",
        "究": "きわ",
        "泣": "な",
        "急": "いそ",
        "救": "すく",
        "嗅": "か",
        "窮": "きわ",
        "去": "さ",
        "居": "い",
        "拒": "こば",
        "挙": "あ",
        "許": "ゆる",
        "叫": "さけ",
        "狂": "くる",
        "供": "そな",
        "挟": "はさ",
        "狭": "せま",
        "恐": "おそ",
        "恭": "うやうや",
        "脅": "おど",
        "強いる": "しいる",
        "強いれ": "しいれ",
        "強いて": "しいて",
        "強": "つよ",
        "教え": "おしえ",
        "教わ": "おそわ",
        "矯": "た",
        "競る": "せる",
        "競り": "せり",
        "競って": "せって",
        "競": "きそ",
        "響": "ひび",
        "驚": "おどろ",
        "仰せ": "おおせ",
        "仰": "あお",
        "凝": "こ",
        "曲": "ま",
        "極": "きわ",
        "近": "ちか",
        "勤": "つと",
        "僅": "わ",
        "謹": "つつし",
        "苦し": "くるし",
        "苦": "にが",
        "駆": "か",
        "愚": "おろ",
        "空": "あ",
        "掘": "ほ",
        "繰": "く",
        "薫": "かお",
        "群": "む",
        "係": "かか",
        "契": "ちぎ",
        "計": "はか",
        "恵": "めぐ",
        "掲": "かか",
        "経": "へ",
        "敬": "うやま",
        "軽や": "かろや",
        "軽": "かる",
        "傾": "かたむ",
        "携": "たずさ",
        "継": "つ",
        "詣": "もう",
        "憩": "いこ",
        "迎": "むか",
        "撃": "う",
        "激": "はげ",
        "欠": "か",
        "決": "き",
        "結わ": "ゆわ",
        "結う": "ゆう",
        "結い": "ゆい",
        "結って": "ゆって",
        "結": "むす",
        "潔": "いさぎよ",
        "見": "み",
        "建": "た",
        "研": "と",
        "兼": "か",
        "健": "すこ",
        "険": "けわ",
        "堅": "かた",
        "嫌": "きら",
        "遣": "つか",
        "賢": "かしこ",
        "懸": "か",
        "言": "い",
        "限": "かぎ",
        "現": "あらわ",
        "減": "へ",
        "厳し": "きびし",
        "厳": "おごそ",
        "古": "ふる",
        "呼": "よ",
        "固": "かた",
        "枯": "か",
        "雇": "やと",
        "誇": "ほこ",
        "顧": "かえり",
        "五": "いつ",
        "互": "たが",
        "後ろ": "うしろ",
        "後れ": "おくれ",
        "後": "あと",
        "悟": "さと",
        "語": "かた",
        "誤": "あやま",
        "巧": "たく",
        "広": "ひろ",
        "交": "まじ",
        "交わ": "かわ",
        "光": "ひか",
        "向": "む",
        "好む": "このむ",
        "好み": "このみ",
        "好": "す",
        "考": "かんが",
        "行": "い",
        "攻": "せ",
        "更": "ふ",
        "効": "き",
        "幸せ": "しあわせ",
        "幸": "さいわ",
        "厚": "あつ",
        "荒": "あら",
        "荒れ": "あれ",
        "荒ら": "あら",
        "香": "かお",
        "耕": "たがや",
        "貢": "みつ",
        "降り": "おり",
        "降ろ": "おろ",
        "降": "ふ",
        "高": "たか",
        "控": "ひか",
        "慌": "あわ",
        "硬": "かた",
        "絞": "しぼ",
        "絞ま": "しま",
        "絞め": "しめ",
        "構": "かま",
        "興": "おこ",
        "乞": "こ",
        "合": "あ",
        "告": "つ",
        "刻": "きざ",
        "黒": "くろ",
        "込": "こ",
        "困": "こま",
        "恨": "うら",
        "混": "ま",
        "懇": "ねんご",
        "唆": "そそのか",
        "差": "さ",
        "座": "すわ",
        "再": "ふたた",
        "災": "わざわ",
        "砕": "くだ",
        "彩": "いろど",
        "採": "と",
        "済": "す",
        "祭": "まつ",
        "細か": "こまか",
        "細": "ほそ",
        "最": "もっと",
        "裁": "さば",
        "催": "もよお",
        "塞": "ふさ",
        "載": "の",
        "在": "あ",
        "作": "つく",
        "削": "けず",
        "搾": "しぼ",
        "咲": "さ",
        "刷": "す",
        "殺": "ころ",
        "撮": "と",
        "擦": "す",
        "三つ": "みつ",
        "参": "まい",
        "惨": "みじ",
        "産": "う",
        "散": "ち",
        "酸": "す",
        "残": "のこ",
        "斬": "き",
        "支": "ささ",
        "止": "と",
        "仕": "つか",
        "四つ": "よつ",
        "死": "し",
        "至": "いた",
        "伺": "うかが",
        "志": "こころざ",
        "使": "つか",
        "刺": "さ",
        "始": "はじ",
        "思": "おも",
        "指": "さ",
        "施": "ほどこ",
        "試み": "こころみ",
        "試": "ため",
        "飼": "か",
        "賜": "たまわ",
        "諮": "はか",
        "示": "しめ",
        "次": "つ",
        "自": "みずか",
        "似": "に",
        "治め": "おさめ",
        "治ま": "おさま",
        "治": "なお",
        "持": "も",
        "慈": "いつく",
        "辞": "や",
        "七": "なな",
        "失": "うしな",
        "執": "と",
        "湿": "しめ",
        "実": "みの",
        "写": "うつ",
        "射": "い",
        "捨": "す",
        "斜": "なな",
        "煮": "に",
        "遮": "さえぎ",
        "謝": "あやま",
        "借": "か",
        "酌": "く",
        "若": "わか",
        "若しくは": "もしくは",
        "弱": "よわ",
        "寂": "さび",
        "守": "まも",
        "取": "と",
        "狩": "か",
        "腫": "は",
        "受": "う",
        "呪": "のろ",
        "授": "さず",
        "収": "おさ",
        "秀": "ひい",
        "周": "まわ",
        "拾": "ひろ",
        "臭": "くさ",
        "臭う": "におう",
        "修": "おさ",
        "終": "お",
        "習": "なら",
        "就": "つ",
        "集め": "あつめ",
        "集ま": "あつま",
        "集": "つど",
        "愁": "うれ",
        "醜": "みにく",
        "蹴": "け",
        "襲": "おそ",
        "充": "あ",
        "住": "す",
        "柔": "やわ",
        "重": "おも",
        "重ね": "かさね",
        "従": "したが",
        "渋": "しぶ",
        "祝": "いわ",
        "宿": "やど",
        "縮": "ちぢ",
        "熟": "う",
        "出": "で",
        "出す": "だす",
        "出し": "だし",
        "述": "の",
        "瞬": "またた",
        "巡": "めぐ",
        "潤む": "うるむ",
        "潤み": "うるみ",
        "潤んで": "うるんで",
        "初": "はじ",
        "書": "か",
        "暑": "あつ",
        "助": "たす",
        "除": "のぞ",
        "少な": "すくな",
        "少": "すこ",
        "召": "め",
        "招": "まね",
        "承": "うけたまわ",
        "昇": "のぼ",
        "消え": "きえ",
        "消": "け",
        "笑": "わら",
        "笑む": "えむ",
        "唱": "とな",
        "商": "あきな",
        "勝": "か",
        "焼": "や",
        "焦げ": "こげ",
        "焦": "あせ",
        "傷": "いた",
        "照": "て",
        "詳": "くわ",
        "障": "さわ",
        "憧": "あこが",
        "償": "つぐな",
        "情": "なさ",
        "畳": "たた",
        "蒸": "む",
        "譲": "ゆず",
        "醸": "かも",
        "拭": "ふ",
        "食べ": "たべ",
        "食": "く",
        "植": "う",
        "殖": "ふ",
        "飾": "かざ",
        "触れ": "ふれ",
        "触": "さわ",
        "織": "お",
        "辱": "はずかし",
        "申": "もう",
        "伸": "の",
        "辛": "から",
        "侵": "おか",
        "振": "ふ",
        "浸": "ひた",
        "深": "ふか",
        "進": "すす",
        "診": "み",
        "寝": "ね",
        "慎": "つつし",
        "新": "あたら",
        "新た": "あらた",
        "震": "ふる",
        "親": "した",
        "尽": "つ",
        "甚": "はなは",
        "尋": "たず",
        "図": "はか",
        "吹": "ふ",
        "垂": "た",
        "炊": "た",
        "衰": "おとろ",
        "推": "お",
        "酔": "よ",
        "遂": "と",
        "数": "かぞ",
        "据": "す",
        "正": "ただ",
        "生": "い",
        "成": "な",
        "青": "あお",
        "省み": "かえりみ",
        "省": "はぶ",
        "逝": "ゆ",
        "清": "きよ",
        "盛": "さか",
        "晴": "は",
        "勢": "いきお",
        "誓": "ちか",
        "静": "しず",
        "請": "こ",
        "請け": "うけ",
        "整": "ととの",
        "赤": "あか",
        "惜": "お",
        "責": "せ",
        "積": "つ",
        "切": "き",
        "折": "お",
        "拙": "つたな",
        "接": "つ",
        "設": "もう",
        "説": "と",
        "絶": "た",
        "占め": "しめ",
        "占": "うらな",
        "専": "もっぱ",
        "浅": "あさ",
        "洗": "あら",
        "染め": "そめ",
        "染": "し",
        "戦": "たたか",
        "煎": "い",
        "羨": "うらや",
        "潜": "もぐ",
        "選": "えら",
        "薦": "すす",
        "鮮": "あざ",
        "全": "まった",
        "全て": "すべて",
        "善": "よ",
        "繕": "つくろ",
        "狙": "ねら",
        "阻": "はば",
        "粗": "あら",
        "組": "く",
        "疎": "うと",
        "訴": "うった",
        "遡": "さかのぼ",
        "早": "はや",
        "争": "あらそ",
        "走": "はし",
        "奏": "かな",
        "送": "おく",
        "捜": "さが",
        "挿": "さ",
        "掃": "は",
        "爽": "さわ",
        "創": "つく",
        "痩": "や",
        "葬": "ほうむ",
        "装": "よそお",
        "遭": "あ",
        "操": "あやつ",
        "騒": "さわ",
        "造": "つく",
        "増": "ま",
        "増や": "ふや",
        "憎": "にく",
        "贈": "おく",
        "足": "た",
        "促": "うなが",
        "捉": "とら",
        "速や": "すみや",
        "速": "はや",
        "測": "はか",
        "続": "つづ",
        "率": "ひき",
        "尊": "とうと",
        "損": "そこ",
        "多": "おお",
        "打": "う",
        "太": "ふと",
        "耐": "た",
        "待": "ま",
        "怠け": "なまけ",
        "怠": "おこた",
        "退": "しりぞ",
        "帯": "お",
        "替": "か",
        "貸": "か",
        "滞": "とどこお",
        "大": "おお",
        "代": "か",
        "濁": "にご",
        "但": "ただ",
        "脱": "ぬ",
        "奪": "うば",
        "担": "にな",
        "探": "さが",
        "淡": "あわ",
        "短": "みじか",
        "嘆": "なげ",
        "綻": "ほころ",
        "鍛": "きた",
        "断": "ことわ",
        "弾": "ひ",
        "暖": "あたた",
        "知": "し",
        "恥": "は",
        "致": "いた",
        "遅れ": "おくれ",
        "遅": "おそ",
        "置": "お",
        "蓄": "たくわ",
        "築": "きず",
        "着": "き",
        "注": "そそ",
        "鋳": "い",
        "著": "あらわ",
        "著し": "いちじるし",
        "弔": "とむら",
        "兆": "きざ",
        "長": "なが",
        "挑": "いど",
        "張": "は",
        "彫": "ほ",
        "眺": "なが",
        "釣": "つ",
        "頂く": "いただく",
        "頂き": "いただき",
        "貼": "は",
        "超": "こ",
        "跳ね": "はね",
        "跳": "と",
        "嘲": "あざけ",
        "澄": "す",
        "調べ": "しらべ",
        "調": "ととの",
        "聴": "き",
        "懲": "こ",
        "直ちに": "ただちに",
        "直": "なお",
        "沈": "しず",
        "珍": "めずら",
        "鎮": "しず",
        "追": "お",
        "通じ": "つうじ",
        "通": "とお",
        "痛": "いた",
        "漬": "つ",
        "低": "ひく",
        "定": "さだ",
        "提": "さ",
        "締": "し",
        "諦": "あきら",
        "摘": "つ",
        "滴": "したた",
        "溺": "おぼ",
        "添": "そ",
        "転": "ころ",
        "伝": "つた",
        "吐": "は",
        "妬": "ねた",
        "渡": "わた",
        "塗": "ぬ",
        "賭": "か",
        "努": "つと",
        "怒": "おこ",
        "当": "あ",
        "投": "な",
        "逃げ": "にげ",
        "逃": "のが",
        "倒": "たお",
        "凍": "こお",
        "凍え": "こごえ",
        "討": "う",
        "透": "す",
        "悼": "いた",
        "盗": "ぬす",
        "登": "のぼ",
        "答": "こた",
        "等": "ひと",
        "統": "す",
        "踏": "ふ",
        "闘": "たたか",
        "同": "おな",
        "動": "うご",
        "働": "はたら",
        "得": "え",
        "独": "ひと",
        "読": "よ",
        "突": "つ",
        "届": "とど",
        "貪": "むさぼ",
        "鈍": "にぶ",
        "曇": "くも",
        "軟": "やわ",
        "難し": "むずかし",
        "難": "かた",
        "二つ": "ふたつ",
        "匂": "にお",
        "入": "い",
        "任": "まか",
        "忍": "しの",
        "認": "みと",
        "熱": "あつ",
        "粘": "ねば",
        "燃": "も",
        "悩": "なや",
        "納": "おさ",
        "濃": "こ",
        "破れ": "やぶれ",
        "破": "や",
        "罵": "ののし",
        "拝": "おが",
        "背": "そむ",
        "配": "くば",
        "敗": "やぶ",
        "廃": "すた",
        "売": "う",
        "培": "つちか",
        "買": "か",
        "白": "しろ",
        "泊": "と",
        "迫": "せま",
        "剝": "は",
        "薄": "うす",
        "縛": "しば",
        "八つ": "やつ",
        "抜": "ぬ",
        "反": "はん",
        "半": "なか",
        "伴": "ともな",
        "煩": "わずら",
        "比": "くら",
        "肥": "こ",
        "卑": "いや",
        "飛": "と",
        "疲": "つか",
        "秘": "ひ",
        "被": "こうむ",
        "悲": "かな",
        "避": "さ",
        "美": "うつく",
        "備": "そな",
        "必": "かなら",
        "表": "あらわ",
        "漂": "ただよ",
        "病": "や",
        "描": "か",
        "貧": "まず",
        "付": "つ",
        "怖": "こわ",
        "負": "ま",
        "赴": "おもむ",
        "浮": "う",
        "富": "と",
        "腐": "くさ",
        "敷": "し",
        "侮": "あなど",
        "舞": "ま",
        "伏": "ふ",
        "覆": "おお",
        "払": "はら",
        "沸": "わ",
        "紛": "まぎ",
        "噴": "ふ",
        "憤": "いきどお",
        "奮": "ふる",
        "分": "わ",
        "文": "モ",
        "聞": "き",
        "併": "あわ",
        "並": "なら",
        "閉": "と",
        "別": "わか",
        "蔑": "さげす",
        "辺": "あた",
        "返": "かえ",
        "変": "か",
        "偏": "かたよ",
        "編": "あ",
        "便": "たよ",
        "歩": "ある",
        "保": "たも",
        "捕": "つか",
        "補": "おぎな",
        "募": "つの",
        "慕": "した",
        "暮": "く",
        "包": "つつ",
        "芳": "かんば",
        "奉": "たてまつ",
        "抱": "だ",
        "放": "はな",
        "倣": "なら",
        "崩": "くず",
        "訪": "たず",
        "報": "むく",
        "豊": "ゆた",
        "飽": "あ",
        "褒": "ほ",
        "縫": "ぬ",
        "亡": "な",
        "乏": "とぼ",
        "忙": "いそが",
        "妨": "さまた",
        "忘": "わす",
        "防": "ふせ",
        "冒": "おか",
        "紡": "つむ",
        "望": "のぞ",
        "傍": "かたわ",
        "暴": "あば",
        "膨": "ふく",
        "謀": "はか",
        "翻": "ひるがえ",
        "磨": "みが",
        "埋": "う",
        "満": "み",
        "眠": "ねむ",
        "務": "つと",
        "無": "な",
        "明": "あか",
        "迷": "まよ",
        "鳴": "な",
        "滅": "ほろ",
        "免": "まぬか",
        "茂": "しげ",
        "黙": "だま",
        "問": "と",
        "躍": "おど",
        "諭": "さと",
        "癒": "い",
        "有": "あ",
        "勇": "いさ",
        "湧": "わ",
        "遊": "あそ",
        "誘": "さそ",
        "憂": "うれ",
        "優": "やさ",
        "与": "あた",
        "余": "あま",
        "誉": "ほま",
        "預": "あず",
        "幼": "おさな",
        "用": "もち",
        "妖": "あや",
        "要": "い",
        "揚": "あ",
        "揺": "ゆ",
        "溶": "と",
        "踊": "おど",
        "養": "やしな",
        "謡": "うた",
        "抑": "おさ",
        "浴": "あ",
        "欲": "ほ",
        "来る": "くる",
        "来な": "こな",
        "来れ": "これ",
        "来ら": "こら",
        "来": "き",
        "頼": "たよ",
        "絡": "から",
        "落": "お",
        "乱": "みだ",
        "利": "き",
        "履": "は",
        "離": "はな",
        "立": "た",
        "流": "なが",
        "良": "よ",
        "涼": "すず",
        "量": "はか",
        "隣": "となり",
        "臨": "のぞ",
        "冷": "つめ",
        "励": "はげ",
        "戻": "もど",
        "例": "たと",
        "麗": "うるわ",
        "劣": "おと",
        "裂": "さ",
        "恋": "こい",
        "連": "つ",
        "練": "ね",
        "老": "お",
        "弄": "もてあそ",
        "朗": "ほが",
        "漏": "も",
        "籠": "こ",
        "六つ": "むつ",
        "和ら": "やわら",
        "和": "なご",
        "話": "はな",
        "賄": "まかな",
        "惑": "まど",
    }
};
export default rt;